import React from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/life-at-tekrevol/Corporate.webp";
import {Container, Row, Col} from "react-bootstrap";

function LearnersTekrevol(props) {
    return (
        <div className="learners_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Corporate">
                            <h2>Corporate Social Responsibility For The Greater Good</h2>
                        </div>
                        <div>
                            <p>We are guided by a strong sense of purpose and a commitment to positively impacting the
                                world. That's why we are dedicated to corporate social responsibility and strive to
                                create sustainable, future-ready solutions that benefit our clients and the
                                community.</p>
                            <p>Whether donating to orphanages and nursing homes, conducting routine visits to charity
                                organizations, organizing and facilitating workshops for the learning and development of
                                our people, or partnering with universities to provide internship opportunities leading
                                to permanent employment, you will find TekRevol at the forefront.</p>
                        </div>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center offset-lg-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>

    );
}

export default LearnersTekrevol;